<template>
	<div class="b-counter" :class="{loading: loading || fictiveLoading}">
		<a href="javascript:void(0);" class="b-counter__icon b-counter__icon_minus" @click.prevent="decrease">-</a>
		<div class="b-counter__inputWrap">
			<input class="b-counter__input" type="hidden" v-model="currentQuantity" :step="measure.ratio"
			       :min="measure.ratio" :max="maxQuantity"
			       @input="update"
			>
			<span class="b-counter__value" v-html="currentQuantity"></span>
		</div>
		<a href="javascript:void(0);" class="b-counter__icon b-counter__icon_plus" @click.prevent="increase">+</a>
	</div>
</template>
<script>

/** Время, пока можно скорректировать количество до отправки запроса на сервер */
const TIME_FOR_CORRECT_COUNT = 300;

/** Время для прелоудера запроса на сервер. Даже если ответ на запрос уже пришел, прелоудер еще будет  */
const TIME_TO_PRELOADER = 500;

	export default {
		name: "Quantity",
		props: {
			id: {
				type: [Number, String],
				default: ""
			},
			quantity: {
				type: Number,
				default: 1
			},
			measure: {
				type: Object,
				default: function () {
					return {
						name: "",
						ratio: 1,
					}
				}
			},
			maxQuantity: {
				type: Number,
				default: 9999
			}
		},
		data: function () {
			return {
				currentQuantity: this.quantity,

				fictiveLoading: false,
				request: false,
				newRequestCount: 0,
			};
		},
		watch: {
			quantity: function () {
				this.currentQuantity = this.quantity;
			}
		},
		computed: {
			loading() {
				return this.$store.getters['basket/loading'](this.id);
			}
		},
		methods: {
			decrease: function () {
				this.update(true, false);
			},
			increase: function () {
				this.update(false, true);
			},
			update: function (checkDecrease, checkIncrease) {
				if (this.fictiveLoading) {
					return;
				}

				checkDecrease = !!checkDecrease;
				checkIncrease = !!checkIncrease;

				let quantityForChecked = this.currentQuantity;
				this.checkStepValue();
				if (checkDecrease) {
					this.checkMinValue();
				}
				if (checkIncrease) {
					this.checkMaxValue();
				}

				//не изменился quantity
				if (quantityForChecked === this.currentQuantity) {
					return;
				}

				this.trySendChanged();
			},
			checkMinValue: function () {
				if (this.currentQuantity > this.measure.ratio) {
					this.currentQuantity -= this.measure.ratio;
				}
			},
			checkMaxValue: function () {
				if ((this.currentQuantity + this.measure.ratio) <= this.maxQuantity) {
					this.currentQuantity += this.measure.ratio;
				}
			},
			checkStepValue: function () {
				if (this.currentQuantity % this.measure.ratio !== 0) {
					this.currentQuantity = Math.floor(this.currentQuantity / this.measure.ratio);
				}
			},
			trySendChanged: function () {
				/* Если нет активных запросов */
				if (!this.request) {
					this.request = true;
				} else {
					this.newRequestCount++; /* счетчик одновременных запросов */
				}

				setTimeout(() => {
					/* К данному моменту есть новый запрос */
					if (this.newRequestCount) {
						this.newRequestCount--;
						return false;
					}

					/* отправка запроса */
					this.fictiveLoading = true;
					this.$emit("fictiveLoading", {id: this.id, fictiveLoading: this.fictiveLoading});
					setTimeout(() => {
						this.sendChanged();
						this.fictiveLoading = false;
						this.$emit("fictiveLoading", {id: this.id, fictiveLoading: this.fictiveLoading});
					}, TIME_TO_PRELOADER);
					this.request = false;
				}, TIME_FOR_CORRECT_COUNT);
			},
			sendChanged: function () {
				this.$emit("change", {id: this.id, quantity: parseFloat(this.currentQuantity)});
			}
		}
	}
</script>